import { render, staticRenderFns } from "./CalmSidebar.vue?vue&type=template&id=165a35e4&scoped=true&"
import script from "./CalmSidebar.vue?vue&type=script&lang=js&"
export * from "./CalmSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CalmSidebar.vue?vue&type=style&index=0&id=165a35e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165a35e4",
  null
  
)

export default component.exports